export enum OrderType {
  All = 'all',
  Sold = 'sold',
  Purchased = 'purchased',
}

export enum OrderStatus {
  All = 'all',
  InProgress = 'in_progress',
  Completed = 'completed',
  Cancelled = 'cancelled',
}
